import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { FooterSection, LeadingTitle } from '@components'
import './AwardProfile.scss'
import { ProfileBukopinAPI, BannerProfileAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { TitleComponent } from '../../../common/components/TitleComponent'
import { useParams } from 'react-router-dom'
import { Accordion, ThumbnailBig } from '../../../common/components'
import MenuProfile from '../MenuProfile'

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const AwardProfileContainer = styled.div`
  background-color: #fff;
  margin-top: 56px;
  padding: 24px 119px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px;
    margin-top: 0;
  }
`

const AwardProfile = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState([])
  const [shortDesc, setShortDesc] = useState({})
  const [isLoading, setisLoading] = useState(false)

  useEffect(async () => {
    setisLoading(true)
    await getDesc()
    loadData()
  }, [])

  const getDesc = async function () {
    const { data } = await BannerProfileAPI({ loc: 'penghargaan' })
    setShortDesc(data.data[0])
  }
  const loadData = async function () {
    const { data } = await ProfileBukopinAPI('')
    setdata(data.data)
    setisLoading(false)
  }
  return (
    <div>
      <TitleComponent title={shortDesc.title} />
      <Container>
        <ThumbnailBig
          title={isLoading ? '' : shortDesc.title}
          desc={isLoading ? '' : shortDesc.description}
          img={isLoading ? '' : shortDesc.banner}
        />
      </Container>

      <AwardProfileContainer>
        <div className="m-0 row d-flex align-items-start">
          <div className="p-0 col-lg-9 col-12">
            {typeof data.dataBlockPenghargaan != 'undefined' &&
              data.dataBlockPenghargaan.length > 0 && (
                <div className="mb-5">
                  <div className="row">
                    {data.dataBlockPenghargaan.map((item, index) => {
                      return (
                        <Accordion key={index} title={item.yearPebghargaan}>
                          {item.contentPenghargaa || item.contentPenghargaan}
                        </Accordion>
                      )
                    })}
                  </div>
                </div>
              )}
          </div>
          <div className="d-none d-lg-block col">
            <MenuProfile active={5} />
          </div>
        </div>
      </AwardProfileContainer>
      <FooterSection currentPage={t('award')} />
    </div>
  )
}

export default AwardProfile
